import _extends from "@babel/runtime/helpers/extends";
import Popup from '@atlaskit/popup';
import { Inline, xcss } from '@atlaskit/primitives';
import React, { useCallback, useState } from 'react';
import { Reaction } from '../Reaction';
import { ReactionSummaryButton } from './ReactionSummaryButton';
const summaryPopupStyles = xcss({
  padding: 'space.100',
  paddingTop: 'space.050',
  maxWidth: '325px'
});

/**
 * Test id for the Reactions summary view popup
 */
export const RENDER_SUMMARY_VIEW_POPUP_TESTID = 'render-summary-view-popup';
export const ReactionSummaryView = ({
  emojiProvider,
  reactions = [],
  flash = {},
  particleEffectByEmoji = {},
  handleOpenReactionsDialog,
  allowUserDialog,
  placement = 'auto-start',
  onReactionClick,
  onReactionFocused,
  onReactionMouseEnter,
  showOpaqueBackground = false
}) => {
  const [isSummaryPopupOpen, setSummaryPopupOpen] = useState(false);
  const handlePopupClose = useCallback(() => setSummaryPopupOpen(false), []);
  const handleSummaryClick = useCallback(() => setSummaryPopupOpen(!isSummaryPopupOpen), [isSummaryPopupOpen]);
  return /*#__PURE__*/React.createElement(Popup, {
    placement: placement,
    content: () => /*#__PURE__*/React.createElement(Inline, {
      xcss: summaryPopupStyles,
      testId: RENDER_SUMMARY_VIEW_POPUP_TESTID,
      space: "space.025",
      shouldWrap: true
    }, reactions.map(reaction => /*#__PURE__*/React.createElement(Reaction, {
      key: reaction.emojiId,
      reaction: reaction,
      emojiProvider: emojiProvider,
      onClick: onReactionClick,
      onFocused: onReactionFocused,
      onMouseEnter: onReactionMouseEnter,
      flash: flash[reaction.emojiId],
      handleUserListClick: handleOpenReactionsDialog,
      allowUserDialog: allowUserDialog,
      showParticleEffect: particleEffectByEmoji[reaction.emojiId]
    }))),
    isOpen: isSummaryPopupOpen,
    onClose: handlePopupClose,
    trigger: triggerProps => /*#__PURE__*/React.createElement(ReactionSummaryButton, _extends({}, triggerProps, {
      emojiProvider: emojiProvider,
      reactions: reactions,
      onClick: handleSummaryClick,
      showOpaqueBackground: showOpaqueBackground
    }))
  });
};